// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__QxMfM","actionsCol":"EnrolledClinics_actionsCol__17NSx"};